<script context='module'>
	/**
	 * @author M.G.
	 */
	import VoiceEditorPopup from './VoiceEditorPopup.svelte';
	import {External, M} from '../../../external';

	export function editVoice(contact, message, onChange, showDate) {

		if (!contact.subscribed) {
			External.Tools.showError(M.CONTACT_NOT_SUBSCRIBED);
			return;
		}

		return new Promise((resolve) => {
			let component;
			External.Tools.showWindow({
				title: '',
				icon: External.Popup.ICON_EDIT,
				width: 650,
				//height: 320,
				addCloseButton: true,
				height: (window.innerHeight * 0.6) + 'px',
				customClass: 'contact-message-dialog',
				isModal: true,
				withDarkBackground: true,
				forceAtRight: false,
				action: {
					onShow: (popup, context) => {
						component = new VoiceEditorPopup({
							target: popup.getContentArea(),
							props: {
								contact: contact,
								popup: popup,
								message: message,
								onChange: onChange,
								showDate: showDate
							}
						});
						resolve(component);
					},
					onHide: () => {
						if (component) {
							component.$destroy();
							component = null;
						}
					}
				}
			});
		});
	}

</script>

<script>
	import VoiceEditor from "./VoiceEditor.svelte";
	import {ignore} from "../../../Common/tools";

	export let popup, contact, message, onChange, showDate;

</script>

<div class='popup-widget-wrapper flex flex-col flex-1 height-100 overflow-auto dynamic-popup-content'
		 style='padding-top: 25px; padding-bottom: 0px;'>

	<VoiceEditor {popup} {contact} {message} {onChange} {showDate} enableScheduling={true}>
		<svelte:fragment slot='footerButtons' let:message let:isMessagingEnabled let:sendNow let:scheduleMessage let:sendScheduledNow let:cancel>

			<div class='f-left contact-message-dialog-footer t-left flex-none'>
				{#if message.id || (message.sendTime && message.sendTime.getTime() > new Date().getTime())}
					<!--existing scheduled message or selected date is in the future-->
					<a on:click={isMessagingEnabled ? scheduleMessage : ignore} class='middle-button f-none inline-block rounded-effect blue'>
						{M.SAVE_MESSAGE}
					</a>
				{:else}
					<a on:click={isMessagingEnabled ? sendNow : ignore} class='middle-button f-none inline-block rounded-effect blue'>
						{M.SEND_MESSAGE}
					</a>
				{/if}

				{#if message.id}
					<a on:click={isMessagingEnabled ? sendScheduledNow : ignore} class='middle-button f-none inline-block rounded-effect gray'>{M.SEND_NOW}</a>
				{/if}
				<a on:click={cancel} class='middle-button f-none inline-block rounded-effect gray ml-5'>{M.CANCEL}</a>
			</div>

		</svelte:fragment>
	</VoiceEditor>

</div>
